/*# sourceMappingURL=medical-history.component-VDGRBOX5.css.map */
